import {
  getTokenRole,
  isFranchisePortalAuthSession,
  isRestaurantImpersonationAuthSession,
  isTabScopedAuthSession,
} from "./authToken";

export const FRANCHISE_ROLE = "resFranchise";

export function isFranchisePortalSession() {
  if (isFranchisePortalAuthSession()) {
    return true;
  }

  if (!isTabScopedAuthSession()) {
    return false;
  }

  const storedRole = sessionStorage.getItem("userRole");
  const tokenRole = getTokenRole(sessionStorage.getItem("tokenLogin"));
  return storedRole === FRANCHISE_ROLE || tokenRole === FRANCHISE_ROLE;
}

export function isFranchiseImpersonationTab() {
  return isRestaurantImpersonationAuthSession();
}

export function getFranchiseId() {
  if (isFranchisePortalSession()) {
    return sessionStorage.getItem("franchiseFK") || "";
  }
  return sessionStorage.getItem("franchiseFK") || localStorage.getItem("franchiseFK");
}
